import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {

// Definimos una expresión regular que solo permite dígitos del 0 al 9
  private regex: RegExp = new RegExp(/^[0-9]*$/);

  // Teclas especiales permitidas (flechas, retroceso, tabulador, etc.)
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Permitir teclas de control
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    // Obtener el valor actual y predecir el siguiente caracter
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    // Si el siguiente caracter no coincide con la regex, prevenir la acción
    if (next && !String(event.key).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    // Validar el texto que se intenta pegar
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text');

    if (pastedText && !this.regex.test(pastedText)) {
      event.preventDefault();
    }
  }
}
